export const AccordionData = [
  {
    title: "01",
    content:
      "A naturally bright, intelligent, and sensitive person procrastinates a lot more than the rest. Studies have shown that the more capable you are of thinking way ahead of potential consequences, either pleasant or unpleasant, the more resistance you would experience to getting things done. Therefore, if you’re still contemplating whether there’s a catch for this FREE Notion planner in exchange for your email address, there isn’t. Because you are FREE to unsubscribe once you get that freebie (No hard feelings, I promise).",
    label: "Accept",
    cta: "Sign up for free",
    link: "/newsletter",
  },
  {
    title: "02",
    content:
      "Emile Chartier once said, “Nothing is more dangerous than an idea when it is the only one you have.” If I may add - as dangerous as it might be, it is one that we all agree. As long as you find yourself agreeing with anything you read, you are on shaky ground. A healthy dose of ambivalence is the right frame of mind towards receiving familiar, new, or conflicting information. You are still the best judge for yourself. Have you challenged yourself, at one point, what you think you know and what you actually know?",
    label: "Analyse",
    cta: "Explore articles",
    link: "/articles",
  },
  {
    title: "03",
    content:
      "As much as I love an inspirational quote such as this by Zig Ziglar - “You don’t have to be great to start, but you have to start to be great.” it is still but a piece of insignificant information. Until that is assimilated into your existing schema, where you took massive, deliberate action, using the right tools for the right job, ideas are just ideas. And if you happen to take some of the tools here and move on to greatness in your work, you might gain popularity and get recognised by the general public for your astounding efficiency. That’s the kind of validation you cannot get from your family and friends who see you as a total train wreck. ",
    label: "Act",
    cta: "Peek at my toolkit",
    link: "/resources",
  },
];
